import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mail"
const MailIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M21 3.75C21.828 3.75 22.5 4.422 22.5 5.25V18.75C22.5 19.578 21.828 20.25 21 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V5.25C1.5 4.422 2.172 3.75 3 3.75zM12 13.749 3 5.829V18.75H21V5.829zM12 11.751 19.387 5.25H4.613z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MailIcon
